// This file was automatically generated from appchart.visitNote.exportProblemsDialog.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.visitNote.exportProblemsDialog');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.ptProblems');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.exportProblemsDialog.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><h2 class="sectionTopHeader el8AlignCenter" style="padding-left:20px; padding-right:20px">', soy.$$escapeHtml(opt_data.headerText), '</h2><ol class="problems-list quickSelectContainer"></ol></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.exportProblemsDialog.problemsList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div>');
  var problemList6024 = opt_data.problems;
  var problemListLen6024 = problemList6024.length;
  for (var problemIndex6024 = 0; problemIndex6024 < problemListLen6024; problemIndex6024++) {
    var problemData6024 = problemList6024[problemIndex6024];
    output.append('<li class="noVerticalSpacing"><div class="el8TableListContainer noBorder"><div class="el8TableListItem noMaxHeight el8AlignLeft"><label class="el8label el8ResetStyle el8Clickable"><input name="problem-checkbox" type="checkbox" class="patientProblem" ', (opt_data.defaultChecked) ? 'checked' : '', ' value="', soy.$$escapeHtml(problemData6024.id), '"></input>');
    el8.template.ptdata.ptProblems.detailedDescription(soy.$$augmentData(problemData6024, {hccScoringEnabled: opt_data.hccScoringEnabled}), output);
    output.append('</label></div></div></li>');
  }
  output.append('</div><li><button class="el8button quickSelectButton" name="export-to-note-button">Export to Note</button></li>');
  if (!opt_sb) return output.toString();
};
